/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import { func, object } from 'prop-types';

import states from 'assets/states.json';
import cities from 'assets/cities.json';

import {
  Col, FormGroup, ValidatedInput, MaskedInput, Row, Select,
} from 'components';

import { getAddressByCep } from '../../services/cep';

import { inputsValidations } from 'validations/inputsFieldsValidations';

export default function AddressForm({
  control, register, errors, setValue, trigger, disableFields, fieldPrefix = ""
}) {
  const [address, setAddress] = useState({
    state: {},
  });

  const fieldsValidations = inputsValidations.BR;

  const findAddressByCep = async (cep) => {
    try {
      const { data } = await getAddressByCep(cep);
      const selectedState = states.filter((state) => state.code === data.uf)[0];
      const selectedCity = cities[selectedState.code].filter((city) => city === data.localidade)[0];
      setAddress({
        state: {
          label: selectedState.name,
          value: selectedState.code,
        },
      });
      setValue(fieldPrefix + 'streetAddress', data.logradouro);
      setValue(fieldPrefix + 'state', {
        label: selectedState.name,
        value: selectedState.code,
      });
      setValue(fieldPrefix + 'city', {
        label: selectedCity,
        value: selectedCity,
      });
      setValue(fieldPrefix + 'neighborhood', data.bairro);
      trigger();
    } catch (error) {}
  };
  const canFindAddressByCep = ({ target: { value } }) => {
    const normalizedValue = value.replace(/_|-/g, '');
    if (normalizedValue.length === 8 && !disableFields) {
      findAddressByCep(normalizedValue);
    }
  };

  const findCityByState = (stateSelected) => {
    setAddress({
      ...address,
      state: stateSelected || {},
    });
  };
  const loadStates = () => states.map((state) => ({
    label: state.name,
    value: state.code,
  }));
  const loadCities = () => (cities[address.state.value] || []).map((city) => ({
    label: city,
    value: city,
  }));

  return (
    <div>
      <Row form>
        <Col md="4">
          <FormGroup>
            <p
              for={fieldPrefix + "zipCode"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Cep
            </p>
            <MaskedInput
              control={control}
              name={fieldPrefix + "zipCode"}
              type="text"
              tabIndex="0"
              defaultValue=""
              format="cep"
              placeholder="Ex.: 12345-123"
              errors={errors}
              rules={{
                required: fieldsValidations.required,
                ...fieldsValidations.cep
              }}
              onChange={canFindAddressByCep}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
        <Col md="8">
          <FormGroup>
            <p
              for={fieldPrefix + "streetAddress"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Endereço
            </p>
            <ValidatedInput
              type="text"
              name={fieldPrefix + "streetAddress"}
              id="streetAddress"
              errors={errors}
              placeholder="Ex.: Avenida Costa e Silva"
              invalid={!!errors.streetAddress}
              maxLength={256}
              innerRef={register({
                required: fieldsValidations.required,
                ...fieldsValidations.communText
              })}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
      </Row>

      
      <Row form>
        <Col md="4">
          <FormGroup>
            <p
              for={fieldPrefix + "number"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Número
            </p>
            <ValidatedInput
              type="text"
              name={fieldPrefix + "number"}
              id="number"
              errors={errors}
              invalid={!!errors.number}
              placeholder="Ex.: 592"
              maxLength={256}
              innerRef={register({
                required: fieldsValidations.required
              })}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
        <Col md="8">
          <FormGroup>
            <p
              for={fieldPrefix + "streetAddress2"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Complemento
            </p>
            <ValidatedInput
              type="text"
              name={fieldPrefix + "streetAddress2"}
              id="streetAddress2"
              errors={errors}
              placeholder=""
              maxLength={256}
              innerRef={register({
                ...fieldsValidations.communText
              })}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md="4">
          <FormGroup>
            <p
              for={fieldPrefix + "province"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Estado
            </p>
            <Select
              control={control}
              name={fieldPrefix + "state"}
              isClearable
              blurInputOnSelect
              errors={errors}
              placeholder="Selecione o estado"
              onChange={findCityByState}
              options={loadStates()}
              maxLength={256}
              rules={{
                required: fieldsValidations.required,
                ...fieldsValidations.communText
              }}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <p
              for={fieldPrefix + "city"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Cidade
            </p>
            <Select
              control={control}
              name={fieldPrefix + "city"}
              blurInputOnSelect
              errors={errors}
              placeholder="Selecione a cidade"
              options={loadCities()}
              maxLength={256}
              rules={{
                required: fieldsValidations.required,
                ...fieldsValidations.communText
              }}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <p
              for={fieldPrefix + "neighborhood"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Bairro
            </p>
            <ValidatedInput
              type="text"
              name={fieldPrefix + "neighborhood"}
              id="neighborhood"
              errors={errors}
              placeholder="Informe o bairro"
              invalid={!!errors.neighborhood}
              maxLength={256}
              innerRef={register({
                required: fieldsValidations.required,
                ...fieldsValidations.communText
              })}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md="6">
          <FormGroup>
            <p
              for={fieldPrefix + "landline"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Telefone fixo
            </p>
            <MaskedInput
              control={control}
              name={fieldPrefix + "landline"}
              placeholder="Ex.: (11) 3224-3212"
              errors={errors}
              maxLength={16}
              rules={{
                validate: (value) => !value || fieldsValidations.phone.pattern.value.test(value) || fieldsValidations.phone.pattern.message
              }}
              options={{
                phone: true,
                phoneRegionCode: 'br',
                prefix: '+55'
              }}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <p
              for={fieldPrefix + "mobile"}
              style={{
                fontSize: 14,
                marginBottom: 4,
              }}
            >
              Telefone celular
            </p>
            <MaskedInput
              control={control}
              name={fieldPrefix + "mobile"}
              placeholder="Ex.: (11) 99999-9999"
              errors={errors}
              maxLength={17}
              rules={{
                required: fieldsValidations.required,
                ...fieldsValidations.phone
              }}
              options={{
                phone: true,
                phoneRegionCode: 'br',
                prefix: '+55'
              }}
              disabled={disableFields}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}

AddressForm.propTypes = {
  control: object.isRequired,
  register: func.isRequired,
  errors: object.isRequired,
};
